var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridLightDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 54,
    viewBox: "0 0 96 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 54,
    fill: "#B8BBCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 40,
    height: 40,
    rx: 2,
    fill: "#F1F1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27.5C28.6406 27.5 30 26.1641 30 24.5C30 22.8594 28.6406 21.5 27 21.5C25.3359 21.5 24 22.8594 24 24.5C24 26.1641 25.3359 27.5 27 27.5ZM29.0859 28.25H28.6875C28.1719 28.5078 27.6094 28.625 27 28.625C26.3906 28.625 25.8047 28.5078 25.2891 28.25H24.8906C23.1562 28.25 21.75 29.6797 21.75 31.4141V32.375C21.75 33.0078 22.2422 33.5 22.875 33.5H31.125C31.7344 33.5 32.25 33.0078 32.25 32.375V31.4141C32.25 29.6797 30.8203 28.25 29.0859 28.25Z",
    fill: "#B8BBCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 7,
    width: 40,
    height: 40,
    rx: 2,
    fill: "#F1F1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 27.5C70.6406 27.5 72 26.1641 72 24.5C72 22.8594 70.6406 21.5 69 21.5C67.3359 21.5 66 22.8594 66 24.5C66 26.1641 67.3359 27.5 69 27.5ZM71.0859 28.25H70.6875C70.1719 28.5078 69.6094 28.625 69 28.625C68.3906 28.625 67.8047 28.5078 67.2891 28.25H66.8906C65.1562 28.25 63.75 29.6797 63.75 31.4141V32.375C63.75 33.0078 64.2422 33.5 64.875 33.5H73.125C73.7344 33.5 74.25 33.0078 74.25 32.375V31.4141C74.25 29.6797 72.8203 28.25 71.0859 28.25Z",
    fill: "#B8BBCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLightDisabled);
export default __webpack_public_path__ + "static/media/grid-light-disabled.0233b77bb.svg";
export { ForwardRef as ReactComponent };